module.exports = __webpack_public_path__ + "static/img/06.25f6563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/06.jpg
// module id = krtO
// module chunks = 0